import { excessSettlementFundsManagerMachine } from '@artblocks/sdk/dist/machines/excess-settlement-funds-manager-machine'
import { createActorContext } from '@xstate/react'

export const ExcessSettlementFundsManagerMachineContext = createActorContext(excessSettlementFundsManagerMachine)
